import { render, staticRenderFns } from "./product-group-add.vue?vue&type=template&id=6b2929ba&scoped=true&"
import script from "./product-group-add.vue?vue&type=script&lang=js&"
export * from "./product-group-add.vue?vue&type=script&lang=js&"
import style0 from "./product-group-add.vue?vue&type=style&index=0&id=6b2929ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2929ba",
  null
  
)

export default component.exports